<template>
  <v-card class="my-4">
    <v-container
      fluid
      @dragover="dragOver"
      @dragleave="dragLeave"
      @drop="drop"
      :class="{ dragging }"
    >
      <v-layout row wrap class="justify-space-between">
        <v-flex md7 xs12>
          <h4>{{ label }}</h4>
          <p v-html="desc"></p>
        </v-flex>
        <v-flex md5 xs12>
          <input
            type="file"
            id="fileInput"
            ref="fileInput"
            style="display: none"
            @change="uploadFilesFromPopup"
            multiple
            accept="image/png,image/jpeg,application/pdf"
          />
          <div v-if="!uploaded" class="d-flex justify-end d-flex-initial">
            <v-btn
              flat
              color="secondary"
              @click="downloadTemplate"
              v-if="template"
            >
              Télécharger le modèle
              <v-icon right class="hidden-sm-and-down">cloud_download</v-icon>
            </v-btn>
            <v-btn color="primary" @click="uploadPopup">
              Ajouter
              <v-icon right class="hidden-sm-and-down">add_circle</v-icon>
            </v-btn>
          </div>
          <div v-else class="d-flex justify-end d-flex-initial align-center">
            <span
              style="font-style: italic"
              v-if="document.driveId.length > 0"
              class="mr-3"
            >
              {{ document.driveId.length }} fichier{{
                document.driveId.length > 1 ? "s" : ""
              }}
              {{ count != null ? `/ ${count}` : "" }}
            </span>
            <v-btn color="accent" @click="remove">
              Retirer
              <v-icon right class="hidden-sm-and-down">remove_circle</v-icon>
            </v-btn>
            <v-btn color="primary" @click="downloadDoc">
              Télécharger
              <v-icon right class="hidden-sm-and-down">cloud_download</v-icon>
            </v-btn>
            <v-btn color="primary" @click="uploadPopup">
              Ajouter
              <v-icon right class="hidden-sm-and-down">add_circle</v-icon>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import { fetchHil } from "../../utils";
import { DOCUMENT_TYPES } from "../../../../webapp-commons/data";
import contentDisposition from "content-disposition";
import { downloadFile } from "../../../../webapp-commons/functions";

export default {
  name: "DocumentChip",
  props: ["document"],
  data() {
    return {
      dragging: false,
      uploadedMsg: false
    };
  },
  methods: {
    dragOver(e) {
      e.stopPropagation();
      e.preventDefault();
      this.dragging = true;
    },
    dragLeave() {
      this.dragging = false;
    },
    drop(e) {
      e.stopPropagation();
      e.preventDefault();
      this.dragging = false;
      this.uploadFiles(e.dataTransfer);
    },
    async downloadDoc() {
      if (!this.uploaded) {
        return;
      }
      const data = await fetchHil(
        `/documents/for/${this.document.leaseId}/document/${this.document._id}`
      );
      await downloadFile(data);
    },
    async downloadTemplate() {
      const data = await fetchHil(
        `/documents/for/${this.document.leaseId}/document/templated/${
          this.template
        }`
      );
      await downloadFile(data);
    },
    uploadPopup() {
      this.$refs.fileInput.click();
    },
    async uploadFilesFromPopup(e) {
      this.uploadFiles(e.target);
    },
    async uploadFiles(dt) {
      for (let f of dt.files) {
        if (!f.type.startsWith("image/") && f.type !== "application/pdf") {
          alert("Seul les images et les pdf sont acceptés");
          return;
        }
      }
      for (let f of dt.files) {
        const formData = new FormData();
        formData.append("file", f);
        const leaseId = this.$store.state.currentProject._id;
        await fetchHil(
          `/documents/for/${leaseId}/document/${this.document._id}/upload`,
          {
            method: "PUT",
            body: formData
          }
        );
        this.uploadedMsg = true;
      }
      this.$emit("change");
    },

    async remove() {
      const leaseId = this.$store.state.currentProject._id;
      await fetchHil(
        `/documents/for/${leaseId}/document/${this.document._id}?fileOnly=true`,
        { method: "DELETE" }
      );
      this.$emit("remove");
    }
  },
  computed: {
    uploaded() {
      return this.document.driveId.length > 0;
    },

    template() {
      const found = DOCUMENT_TYPES.filter(
        ({ value }) => value === this.document.title
      );
      if (found.length > 0) {
        return found[0].templated;
      } else {
        return null;
      }
    },

    label() {
      const found = DOCUMENT_TYPES.filter(
        ({ value }) => value === this.document.title
      );
      if (found.length > 0) {
        return found[0].text;
      } else {
        return this.document.title;
      }
    },

    count() {
      const found = DOCUMENT_TYPES.filter(
        ({ value }) => value === this.document.title
      );
      if (found.length > 0) {
        return found[0].count || null;
      } else {
        return null;
      }
    },

    desc() {
      const found = DOCUMENT_TYPES.filter(
        ({ value }) => value === this.document.title
      );
      if (found.length > 0) {
        return found[0].desc;
      } else {
        return "";
      }
    },

    href() {
      return `/v1/documents/for/${this.document.leaseId}/document/${
        this.document._id
      }`;
    }
  }
};
</script>

<style scoped>
.dragging {
  background-color: #ff7c5d !important;
  color: white !important;
  border: 0 !important;
}

.dragging .v-btn {
  display: none;
}
</style>
